import React from "react";
import { useFormContext } from "react-hook-form";
import CField from "$forms/CField";
import AddressSelect from "$forms/AddressSelect";
import PostalCode from "$forms/PostalCode";
import { useDockyardFormContext } from "../context/DockyardFormContext";
import { useDockyardStyles } from "../styles";

export const AddressSection: React.FC = () => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const classes = useDockyardStyles();
  const { country, canEdit } = useDockyardFormContext();

  const handleAddressChange = (data: any) => {
    if (Array.isArray(data)) {
      let street = "";

      data.forEach((elem: any) => {
        if (elem.types.includes("postal_code")) {
          setValue("postalCode", elem.long_name);
        }
        if (elem.types.includes("country")) {
          setValue("country", elem.long_name);
        }
        if (elem.types.includes("locality")) {
          setValue("city", elem.long_name);
        }
        if (elem.types.includes("street_number")) {
          if (street === "") {
            street += elem.long_name;
          } else {
            street = `${elem.long_name}${street}`;
          }
        }
        if (elem.types.includes("route")) {
          street += ` ${elem.long_name}`;
        }
      });
      setValue("address", street);
    } else {
      setValue("address", data);
    }
  };

  return (
    <>
      <div className={classes.newFormFieldsRow}>
        <CField
          control={control}
          label="Adresse"
          name="address"
          error={errors.address}
        >
          {(props: any) => (
            <AddressSelect
              value={props.value}
              disabled={!canEdit}
              onChange={handleAddressChange}
            />
          )}
        </CField>
      </div>

      <div className={classes.newFormFieldsRow}>
        <CField
          control={control}
          label="Complément d'adresse"
          disabled={!canEdit}
          name="address2"
          error={errors.address2}
        />
      </div>

      <div className={classes.newFormFieldsRow}>
        <div className={classes.newFormFieldSmallCol}>
          <PostalCode
            disabled={!canEdit}
            control={control}
            name="postalCode"
            error={errors.postalCode}
            country={country}
            required={false}
          />
        </div>
        <div className={classes.newFormFieldsCol}>
          <CField
            control={control}
            label="Ville"
            name="city"
            error={errors.city}
          />
        </div>
        <div className={classes.newFormFieldSmallCol}>
          <CField
            control={control}
            label="Pays"
            disabled={!canEdit}
            name="country"
            error={errors.country}
          />
        </div>
      </div>
    </>
  );
};
